// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { telosTestnet as _telosTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the telosTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 41
 * Chain Name: Telos
 * Default Block Explorer: https://testnet.teloscan.io/
 * Default RPC URL: https://testnet.telos.net/evm
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { telosTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: telosTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const telosTestnet = createCommon({
	..._telosTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
